import removeMarkdown from 'markdown-to-text';
import htmlToText from 'html-to-text';
import { sectionPrefix } from '../../client/components/NavigationMenu/utils';
import { toUrlFormat } from '../treeVisitors';

export const removeHtmlFromTxt = (html) =>
  htmlToText.fromString(html, {
    wordwrap: false,
    ignoreHref: true,
    ignoreImage: true,
    uppercaseHeadings: false,
    preserveNewlines: true,
  });

const removeNewLinesAndExtraSpace = (text) =>
  text.replace(/\s\s+/g, ' ').replace(/\n/g, ' ').trim();

export const removeBreakingSpaces = (str) => {
  /*
      We have on some markdowns breaking spaces inside (looks like regular space but it's not)
      thats breaks the UI, this function replace all those weird spaces to regular spaces.
    */

  // eslint-disable-next-line no-irregular-whitespace
  return str.replace(/ /g, ' ');
};

export const removeMarkdownFromText = (textWithMarkdownAndHtml) => {
  try {
    const textWithMarkdown = removeHtmlFromTxt(textWithMarkdownAndHtml);
    const plainText = removeMarkdown(textWithMarkdown);
    return removeBreakingSpaces(removeNewLinesAndExtraSpace(plainText));
  } catch (err) {
    console.error(
      'Error occurred while trying to remove markdown from a string:: ',
      err,
    );
    return textWithMarkdownAndHtml;
  }
};

export const getMdName = (md) =>
  md && (md.displayName || (md.name ? md.name.replace('.md', '') : ''));

export const getMarkdownPath = (mdName, prefix) => {
  const mdUrlFormat = toUrlFormat(mdName);
  return sectionPrefix(prefix, mdUrlFormat);
};
